import './Header.css';

const Header = () => (
  <div className="site-header">
    <h1 className="site-header__heading">
      <span className="site-header__heading-p1">Isabel</span>
      <span className="site-header__heading-p2">Walks the National Trails</span>
    </h1>
  </div>
);

export default Header;
